/**
 * Text Cleaner Utility
 * Removes em-dashes and other unwanted characters from AI-generated content
 */

/**
 * Remove em-dashes (—) from text while preserving regular hyphens (-)
 * @param {string} text - The text to clean
 * @returns {string} - Cleaned text with em-dashes replaced by hyphens
 */
export const removeEmDashes = (text) => {
  if (!text || typeof text !== 'string') return text;
  
  // Replace em-dash (—) with regular hyphen (-)
  // Also handle en-dash (–) which is sometimes confused with em-dash
  return text
    .replace(/—/g, '-')  // Em-dash
    .replace(/–/g, '-')  // En-dash
    .replace(/\u2014/g, '-')  // Unicode em-dash
    .replace(/\u2013/g, '-'); // Unicode en-dash
};

/**
 * Clean all text content in an object recursively
 * @param {any} obj - Object to clean
 * @returns {any} - Cleaned object
 */
export const cleanTextInObject = (obj) => {
  if (!obj) return obj;
  
  if (typeof obj === 'string') {
    return removeEmDashes(obj);
  }
  
  if (Array.isArray(obj)) {
    return obj.map(item => cleanTextInObject(item));
  }
  
  if (typeof obj === 'object') {
    const cleaned = {};
    for (const key of Object.keys(obj)) {
      cleaned[key] = cleanTextInObject(obj[key]);
    }
    return cleaned;
  }
  
  return obj;
};

export default {
  removeEmDashes,
  cleanTextInObject
};
